import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    NumberField,
    SelectInput,
    Filter,
    DeleteWithConfirmButton,
    useNotify,
    useRefresh,
    useListContext, EditButton,
} from 'react-admin';
import { makeStyles } from "@material-ui/core/styles";


const weekDayNames = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
};

const WeekDayField = ({ record, source }) => {
    const weekDayValue = record ? record[source] : null; // Get the week_day value from the record
    const weekDayName = weekDayNames[weekDayValue] || 'Unknown'; // Map the value to the name
    return <span>{weekDayName}</span>; // Return the day name wrapped in a span
};
const AppointmentSettingFilter = (props) => (
    <Filter {...props}>
        <SelectInput
            source="branch_id"
            label="Branch"
            choices={[
                { id: '1', name: 'Branch 1' },
                { id: '2', name: 'Branch 2' },
                { id: '3', name: 'Branch 3' },
                // Add actual branch choices here
            ]}
        />
    </Filter>
);

// Define custom styles for the header
const useStyles = makeStyles({
    headerCell: {
        backgroundColor: '#def',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '10px',
    },
});

const AppointmentSettingList = (props) => {
    const classes = useStyles();
    const notify = useNotify();
    const refresh = useRefresh();

    return (
        <List
            {...props}
            bulkActionButtons={false}
            filters={<AppointmentSettingFilter />}
            perPage={10}  // Set the number of items per page
        >
            <Datagrid rowClick="edit" classes={{ headerCell: classes.headerCell }}>
                <TextField source="branchName" label="Branch Name" />
                <TextField source="appointment_start_time" label="Start Time" />
                <TextField source="appointment_end_time" label="End Time" />
                <NumberField source="appointment_interval" label="Interval (mins)" />
                <NumberField source="max_appointments_per_slot" label="Max Appointments" />
                <WeekDayField source="week_day" label="Week Day" />
                <EditButton />
                <DeleteWithConfirmButton
                    confirmTitle={"Delete?"}
                    confirmContent={"Do you want to delete this appointment setting?"}
                />
            </Datagrid>
        </List>
    );
};

export default AppointmentSettingList;
